import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../../../../redux/store/store";
import CustomInput from "../../../../../../../Components/CustomInputs/CustomInput";
import { updateFirstStepDynamicFields } from "../../../../../../../redux/reducers/claimReducer";
import { handleShowErrorMessage } from "../../../../../../../redux/reducers/claimFieldErrorsReducer";
import { shouldRenderSpecField } from "../../../../../../../redux/reducers/visibilityMatrixesReducer";
import { useScrollToTopErrorInput } from "../../../../../../../CustomHooks/useScrollToTopErrorInput";

const PermConsequencesTimeOfClaimField: React.FC = () => {
   const dispatch = useDispatch();

   const TimeOfClaimValue = useSelector(
      (state: StoreType) =>
         state.claimState.injuryDescriptionModelBase.injuryDescriptionModel.find(
            (model) => model.typeOfClaimEnum === 7
         )?.timeOfClaim
   );
   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );

   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );
   const ref = React.useRef<HTMLDivElement>(null);
   useScrollToTopErrorInput(ref, "permconsequences.DateOfClaimFrom");
   return (
      <CustomInput
         labelText="V kolik hodin se úraz stal"
         placeholderText="Uveďte čas"
         name="TimeOfClaim"
         value={TimeOfClaimValue || ""}
         onChange={(e) => {
            dispatch(
               updateFirstStepDynamicFields({
                  value: e.target.value,
                  field: "timeOfClaim",
                  typeOfClaimEnum: 7,
               })
            );
         }}
         validationText={handleShowErrorMessage(
            "permconsequences.TimeOfClaim",
            claimFieldErrorsMessages
         )}
         dependencyValue={shouldRenderSpecField(
            "permconsequences",
            "TimeOfClaim",
            visibilityMatrixes
         )}
         inputRef={ref}
      />
   );
};

export default PermConsequencesTimeOfClaimField;
